import { Component } from '@angular/core';
import {
  RestorationMetricDescriptionWidgetComponent,
} from '../widgets/restoration-metric-description-widget/restoration-metric-description-widget.component';
import {
  RestorationMetricImpactLevelWidgetComponent,
} from '../widgets/restoration-metric-impact-level-widget/restoration-metric-impact-level-widget.component';
import {
  RestorationStateLevelMetricComponent,
} from '../widgets/restoration-state-level-metric/restoration-state-level-metric.component';
import {
  RestorationMetricAucWidgetComponent,
} from '../widgets/restoration-metric-auc-widget/restoration-metric-auc-widget.component';
import {
  OutageDurationDefinitionWidgetComponent,
} from '../widgets/outage-duration-definition-widget/outage-duration-definition-widget.component';
import {
  RestorationMetricRecoveryDurationWidgetComponent,
} from '../widgets/restoration-metric-recovery-duration-widget/restoration-metric-recovery-duration-widget.component';

@Component({
  selector: 'tgrid-restoration-metric-page',
  templateUrl: './restoration-metric-page.component.html',
  imports: [
    RestorationMetricDescriptionWidgetComponent,
    RestorationMetricImpactLevelWidgetComponent,
    RestorationMetricDescriptionWidgetComponent,
    RestorationStateLevelMetricComponent,
    RestorationMetricAucWidgetComponent,
    OutageDurationDefinitionWidgetComponent,
    RestorationMetricRecoveryDurationWidgetComponent,
  ],
  styleUrls: ['./restoration-metric-page.component.scss'],
})
export class RestorationMetricPageComponent {
}
